// eslint-disable-next-line @typescript-eslint/no-unused-vars
const InputBase = theme => {
  return {
    MuiInputBase: {
      variants: [{
        props: {
          size: 'medium'
        },
        style: {
          height: 36
        }
      }, {
        props: {
          size: 'small'
        },
        style: {
          height: 30
        }
      }, {
        props: {
          size: 'large'
        },
        style: {
          height: 42
        }
      }],
      styleOverrides: {
        input: {
          boxSizing: 'border-box'
        }
      }
    }
  };
};

export { InputBase };
